export default __webpack_public_path__ + "static/media/popup-diagonal-right-bottom.0c366e7e.svg";